module.exports = __webpack_public_path__ + "img/item_Story_04.50cb29a1.jpeg";